export default __webpack_public_path__ + "static/media/journeytray-bluetree-nutflower.388d72d8.svg";